import { GlassPanel } from '../common/GlassPanel';
import { CameraPreview } from './CameraPreview';
import { DeviceSelect } from './DeviceSelect';

interface VideoSettingsPanelProps {
  cameras: { deviceId: string; label: string }[];
  selectedCamera: string;
  onSelectCamera: (id: string) => void;
  cameraStream: MediaStream | null;
}

/**
 * Panel for camera configuration and preview.
 */
export function VideoSettingsPanel({
  cameras,
  selectedCamera,
  onSelectCamera,
  cameraStream,
}: VideoSettingsPanelProps) {
  return (
    <GlassPanel variant="strong" className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold">Video</h2>
        <p className="text-ink-200 text-sm">
          Confirm your camera feed before joining a meeting.
        </p>
      </div>
      <DeviceSelect
        label="Camera"
        devices={cameras}
        selectedId={selectedCamera}
        onSelect={onSelectCamera}
      />
      <CameraPreview stream={cameraStream} />
    </GlassPanel>
  );
}
